
import SpinnerLoader from "../../../../assets/loader/SpinnerLoader";
import Stepper from "../../../components/AltProductPortfolioPage/Stepper/View/Stepper";
import AltProductPortfolioController from "../Controller/AltProductPortfolioPageController";
import { Suspense, lazy } from "react";
import '../Styles/AltProductPortfolioPageStyles.css'
import { Products } from "../Model/AltProductPortfolioPageModel";

const AltProductDiffWebAppPageView = lazy(() => import("../../../components/AltProductPortfolioPage/AltProductDiffWebAppPage/View/AltProductDiffWebAppPageView"));
const AltProductDiffWebAppPageMobileView = lazy(() => import("../../../components/AltProductPortfolioPage/AltProductDiffWebAppPage/View/AltProductDiffWebAppPageMobileView"));
const FeaturesBenefits = lazy(() => import("../../../components/AltProductPortfolioPage/AltProductFeatureAndBenefits/View/FeaturesBenefits"));
const AltProductPortfolioKeyFeaturesPageView = lazy(() => import("../../../components/AltProductPortfolioPage/AltProductPortfolioKeyFeaturesPage/View/AltProductPortfolioKeyFeaturesPageView"));
const AltProductPortfolioKeyInstallationPageView = lazy(() => import("../../../components/AltProductPortfolioPage/AltProductPortfolioKeyInstallationPage/View/AltProductPortfolioKeyInstallationPageView"));
const AltProductPortfolioMobileAppPageView = lazy(() => import("../../../components/AltProductPortfolioPage/AltProductPortfolioMobileAppPage/View/AltProductPortfolioMobileAppPageView"));
const AltProductMobileWebAppScreen = lazy(() => import("../../../components/AltProductPortfolioPage/AltProductWebAppPage/View/AltProductMobileWebAppScreen"));
const AltProductPortfolioProductDetailPageView = lazy(() => import("../../../components/AltProductPortfolioPage/AltProductPortfolioProductDetailPage/View/AltProductPortfolioProductDetailPageView"));
const AltProductWebAppScreen = lazy(() => import("../../../components/AltProductPortfolioPage/AltProductWebAppPage/View/AltProductWebAppScreen"));
const ProductPortfolioProductPartnersView = lazy(() => import("../../../components/ProductPortfolioPage/ProductPortfolioProductPartner/View/ProductPortfolioProductPartnersView"));
const ProductPortfolioProductsSpecificationsandGuranteesView = lazy(() => import("../../../components/ProductPortfolioPage/ProductPortfolioProductsSpecificationsandGurantees/View/ProductPortfolioProductsSpecificationsandGuranteesView"));
const AltProductPortfolioMainPageView = lazy(() => import("../../../components/AltProductPortfolioPage/AltProductPortfolioMainPage/View/AltProductPortfolioMainPageView"));
const AltProductPortfolioMainPageMobileView = lazy(() => import("../../../components/AltProductPortfolioPage/AltProductPortfolioMainPage/View/AltProductPortfolioMainPageMobileView"));
const AltProductPortfolioKeyFeaturesPageMobileView = lazy(() => import("../../../components/AltProductPortfolioPage/AltProductPortfolioKeyFeaturesPage/View/AltProductPortfolioKeyFeaturesPageMobileView"));
const AltProductPortfolioProductCatalogPageView = lazy(() => import("../../../components/AltProductPortfolioPage/altproductportfolioproductcatalogpage/View/AltProductPortfolioProductCatalogPageView"));
const AltProductSolutionsView = lazy(() => import("../../../components/AltProductPortfolioPage/AltProductSolutions/View/AltProductSolutionsView"));

const AltProductPortfolioPageView = () => {

  const { productIndex,
    currentStep,
    setCurrentStep,
    scrollToStep,
    sectionRefs,
    product,
    useIsMobile
  } = AltProductPortfolioController();
  const { isMobile1, isMobile2, isMobile3 } = useIsMobile()


  if (productIndex === -1 || productIndex === null) return <SpinnerLoader />;

  return (
    <div className="alt-product-portfolio-page-container">
      <Suspense fallback={<SpinnerLoader />}>

        {isMobile2 ? (
          <AltProductPortfolioMainPageMobileView {...product} />
        ) : (
          <AltProductPortfolioMainPageView {...product} setCurrentStep={setCurrentStep} />
        )}
      </Suspense>

      {(productIndex >= 0 && productIndex <= 2) ? (
        isMobile3 ? (
          <AltProductDiffWebAppPageMobileView data={Products[productIndex]?.WebAppDifferentiation} />
        ) : (
          <AltProductDiffWebAppPageView data={Products[productIndex]?.WebAppDifferentiation} />
        )
      ) : null}

      <Stepper step={Products[productIndex]?.steps} currentStep={currentStep} setCurrentStep={setCurrentStep} scrollToStep={scrollToStep} />

      <div ref={(el) => (sectionRefs.current["features"] = el)} style={{ padding: "20px 0", scrollMarginTop: "100px" }}>
        {isMobile1 && product?.topBranches ? (
          <AltProductPortfolioKeyFeaturesPageMobileView {...product} />
        ) : product?.ProductFeatureSvg ? (
          <AltProductPortfolioKeyFeaturesPageView {...product} />
        ) : null}
      </div>

      <div ref={(el) => (sectionRefs.current["installation"] = el)} style={{ padding: "20px 0", scrollMarginTop: "100px" }}>
        {product?.features && <AltProductPortfolioKeyInstallationPageView features={product.features} />}
      </div>

      <div ref={(el) => (sectionRefs.current["benefits"] = el)} style={{ padding: "20px 0", scrollMarginTop: "100px" }}>
        {product?.featuresBenefits && <FeaturesBenefits featuresBenefits={product.featuresBenefits} />}
      </div>

      <div ref={(el) => (sectionRefs.current["solutions"] = el)} style={{ padding: "20px 0", scrollMarginTop: "100px" }}>



        {product?.AltProductSolutions && (
          isMobile2 ? (
            <AltProductSolutionsView AltProductSolutions={product.AltProductSolutionsMobile} />
          ) : (
            <AltProductSolutionsView AltProductSolutions={product.AltProductSolutions} />
          )
        )}
      </div>

      <div ref={(el) => (sectionRefs.current["catalog"] = el)} style={{ padding: "20px 0", scrollMarginTop: "100px" }}>
        {product?.ProductCatalog && (
          <AltProductPortfolioProductCatalogPageView ProductCatalog={product.ProductCatalog} />
        )}
      </div>

      <div ref={(el) => (sectionRefs.current["application"] = el)} style={{ padding: "20px 0", scrollMarginTop: "100px" }}>
        {product?.ApplicationPageHeading && (
          <AltProductPortfolioMobileAppPageView
            ApplicationPageHeading={product?.ApplicationPageHeading}
            MobileApplication={product?.MobileApplication}
            Application={product?.Application}
          />
        )}
      </div>

      <div>
        {product?.WebApplicationModel && (
          isMobile2 ? (
            <AltProductMobileWebAppScreen WebApplicationModel={product.WebApplicationModel} />
          ) : (
            <AltProductWebAppScreen WebApplicationModel={product.WebApplicationModel} />
          )
        )}
      </div>


      <div ref={(el) => (sectionRefs.current["enquirenow"] = el)} style={{ padding: "20px 0", scrollMarginTop: "100px" }}>
        <AltProductPortfolioProductDetailPageView {...product} />
      </div>


      {product?.specificationandwarranty.length > 0 && <div ref={(el) => (sectionRefs.current["specifications"] = el)} style={{ padding: "20px 0", scrollMarginTop: "100px" }}>
        <ProductPortfolioProductsSpecificationsandGuranteesView
          specificationandwarranty={product?.specificationandwarranty}
          specifications={product?.specifications}
        />
      </div>}

      <ProductPortfolioProductPartnersView partners={product?.partners} />

    </div >
  );
};

export default AltProductPortfolioPageView;
